export function initialize() {
  // Modaal
  // http://humaan.com/modaal/
  // ----------------------------------------------------------------------------

  $('.lead-gen-modal-trigger').modaal({
    width: 1218
  })

  $('.cta-modal-trigger').modaal({
    width: 1218
  })

  $('.cta-phone-trigger').modaal()

  // --------------------------------------------------------------------------
  // The 'You're Leaving Vestmark' modal.

  let leavingUrl = '';
  let leavingModalContainers = document.querySelectorAll('.js-leaving-modal');
  let leavingEls = [];
  let stayButton = document.querySelector('.cta-leaving__stay');
  let continueLink = document.querySelector('.cta-leaving__continue');

  const allowedDomains = [
    '/',
    'mailto:',
    'tel:',
    'https://localhost:3000',
    'https://www.vestmark.com',
    'https://vestmark.com',
    'https://vestmark-craft.staging.servd.dev',
    'https://vestmark.test',
    'https://vestmark-marketing-website-content.s3.amazonaws.com',
    'https://assets.vestmark.com',
    'https://asset-transforms.vestmark.com'
  ];

  // Loop through each container
  leavingModalContainers.forEach(container => {
    // Collect all anchor elements within the current container
    const anchors = container.querySelectorAll('a');
    
    // Filter anchors that do not start with any of the allowed domains (from above array)
    anchors.forEach(anchor => {
      const href = anchor.getAttribute('href');
      if (!href) return;
    
      const tempAnchor = document.createElement('a');
      tempAnchor.href = href;
      const absoluteHref = tempAnchor.href;
    
      const isAllowed = allowedDomains.some(prefix =>
        prefix === '/' 
          ? absoluteHref.startsWith(window.location.origin)
          : href.startsWith(prefix) || absoluteHref.startsWith(prefix)
      );
    
      if (!isAllowed) {
        leavingEls.push(anchor);
      }
    });
  });

  if (leavingEls.length > 0) {
    // Deal with the Leaving modal trigger being an anchor to another URL.
    leavingEls.forEach((link) => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        leavingUrl = this.href;
        continueLink.setAttribute('href', leavingUrl);
      });
    });

    // If there are any leaving elements, initialize the modal
    $(leavingEls).modaal({
      content_source: '#cta-leaving',
      hide_close: true,
      width: 770
    });
  }

  // Custom in-modal "Stay" (close) button.
  stayButton.addEventListener('click', () => {
    $(leavingEls).modaal('close');
  });

  // --------------------------------------------------------------------------
}
